<template>
  <div class="sky-step-component">
    <component
      :data="data"
      :name="viewComponent"
      :is="viewComponent == 'SkyStepViewDefault' ? name : viewComponent"
      @handelToAutoNext="handelToAutoNext"
      @changeProjectId="changeProjectId"
      @changeStage="changeStage"
      @showBtns="showBtns"
      @restartInterval="restartInterval"
      @openChangeDialog="openChangeDialog"
    ></component>
  </div>
</template>

<script>
import {} from 'element-ui'
//扫描组件包，动态挂载到components
const components = require.context('./metadata/demandSurvey', true, /\.vue$/)
let obj = {}
components.keys().forEach(ele => {
  let fileName = components(ele).default.name
  obj[fileName] = components(ele).default
})

const order = require.context('./metadata/order', true, /\.vue$/)
order.keys().forEach(ele => {
  let fileName = order(ele).default.name
  obj[fileName] = order(ele).default
})

export default {
  name: 'SkyStepComponent',
  props: {
    name: String,
    viewComponent: String,
    data: Object,
    customData: Object,
    formInfo: Object
  },
  components: obj,
  created() {},
  methods: {
    handelToAutoNext() {
      this.$emit('handelToAutoNext')
    },
    openChangeDialog(param) {
      this.$emit('openChangeDialog', param)
    },
    changeProjectId(param) {
      this.$emit('changeProjectId', param)
    },
    restartInterval() {
      this.$emit('restartInterval', {})
    },
    changeStage(params) {
      this.$emit('changeStage', params)
    },
    showBtns(param) {
      this.$emit('showBtns', param)
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(step-component) {
  position: relative;
  height: 100%;
}
</style>
